function AssociationNode(aAssociation, aEnrollee, aPhoto) {
    this.Identifier = "";
    this.Title = "";
    this.SubTitle = "";
    this.IconUrl = "User.png";
    this.Id = -1;
    this.ConnectionId = -1;
    if (aEnrollee) {
        var lDevice = GetDevice(aAssociation.DeviceId);
        var lOrganization = getDataItem(aEnrollee.OrganizationId, 'Organizations');
        this.Identifier = aEnrollee.Id.toString();
        this.Title = aEnrollee.FullName + ' (' + aEnrollee.PrimaryId + ')';
        this.SubTitle = (lOrganization ? lOrganization.Name : "");
        this.Id = aEnrollee.Id;
        this.ConnectionId = aAssociation.PointGroupingId;
    }
    if (aPhoto) {
     //   this.IconUrl = aPhoto.PhotoUri;
    }
}
if (typeof exports !== 'undefined') {
    module.exports = AssociationNode;
}